import type { QuoteDocumentTemplateSummary } from "@forgepoint/shared";

/** The name a new empty template starts with, before the user renames it. */
const UNTITLED_TEMPLATE_NAME = "Untitled template";

/**
 * Picks the first "Untitled template" name no existing template holds, so a
 * fresh template never collides with one created earlier and left unnamed.
 * @param templates - The org's current templates
 * @returns "Untitled template", or "Untitled template N" when that is taken
 */
export function untitledTemplateName(
  templates: readonly QuoteDocumentTemplateSummary[],
): string {
  const taken = new Set(templates.map((template) => template.name));
  const candidates = Array.from({ length: taken.size + 1 }, (_, index) =>
    index === 0
      ? UNTITLED_TEMPLATE_NAME
      : `${UNTITLED_TEMPLATE_NAME} ${index + 1}`,
  );
  return candidates.find((candidate) => !taken.has(candidate)) ?? "";
}
